import { Loader2 } from 'lucide-react';
import { cn } from '../lib/cn';

export interface LoadingProps {
  /** Optional message rendered next to the spinner. */
  label?: string;
  /** Size of the spinner glyph. Defaults to `sm`. */
  size?: 'sm' | 'md' | 'lg';
  /** When true, fills the parent and centres the spinner. */
  fullHeight?: boolean;
  className?: string;
}

const SPINNER_SIZE: Record<NonNullable<LoadingProps['size']>, string> = {
  sm: 'h-4 w-4',
  md: 'h-6 w-6',
  lg: 'h-8 w-8',
};

/**
 * Lightweight loading indicator. Used inline next to text or as a centred
 * full-panel spinner when `fullHeight` is set.
 */
export function Loading({ label, size = 'sm', fullHeight = false, className }: LoadingProps) {
  return (
    <div
      role="status"
      aria-live="polite"
      className={cn(
        'flex items-center gap-2 text-slate-500',
        fullHeight && 'h-full w-full justify-center py-12',
        className,
      )}
    >
      <Loader2 className={cn('animate-spin text-slate-400', SPINNER_SIZE[size])} />
      {label && <span className="text-sm">{label}</span>}
    </div>
  );
}
